// Constants for holiday calendar feature

// Predefined color palette (8 distinct colors)
export const HOLIDAY_COLORS = [
  'hsl(210, 70%, 60%)', // Blue
  'hsl(340, 70%, 60%)', // Red/Pink
  'hsl(150, 70%, 50%)', // Green
  'hsl(30, 80%, 60%)', // Orange
  'hsl(270, 70%, 60%)', // Purple
  'hsl(180, 65%, 55%)', // Cyan
  'hsl(45, 75%, 60%)', // Yellow
  'hsl(0, 0%, 50%)', // Gray
] as const;

// Storage key for localStorage
export const STORAGE_KEY = 'certhon:holidays' as const;

// Storage version for migrations
export const STORAGE_VERSION = 1 as const;

// Default calendar configuration
export const DEFAULT_CALENDAR_ID = 'default-dutch-holidays' as const;
export const DEFAULT_CALENDAR_NAME = 'Dutch Holidays' as const;

// API endpoint for default holidays
export const DEFAULT_HOLIDAYS_ENDPOINT = '/api/holidays/default.ics' as const;

// File upload constraints
export const MAX_FILE_SIZE = 1024 * 1024; // 1MB
export const ACCEPTED_FILE_TYPES = ['.ics', '.ical'] as const;
export const ACCEPTED_MIME_TYPES = ['text/calendar'] as const;

// Recurring event expansion range (years)
export const RECURRING_EVENT_YEARS = 2 as const;
